import { Image, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { DinningLayoutProps } from './DinningLayout.types';
import PagePath from '../../components/PagePath';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import UserWebInfo from '../../components/UserWebInfo';
import Sidebar from '../../components/Sidebar';
import { DINNING_TABS } from './DinningLayout.constants';
import { STYLE_VARS } from '../../constants/style-vars';
import { Promotions } from '../../screens/Home/components/Promotions';
import { NavigationService } from '../../services/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { Category } from '../../types/categories.types';
import { PromotionFilter, setLoadingPromotion, setPromotionFilter, setPromotions, setTotal } from '../../services/redux/reducers/PromotionSlice';
import { PromotionsApi } from '../../services/api';
import { COLORS, FONTS } from '../../constants';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { filter_button, reset_icon } from '../../assets/base64';
import { decode } from 'html-entities';

const DinningLayout: FC<DinningLayoutProps> = ({
  title,
  children,
  current = -1,
  icon,
  haveGoBackButton = false,
}) => {
  const dispatch = useDispatch();
  const { promotionFilter } = useSelector((state: RootState) => state.promotionReducer);

  const [promotionCategories, setPromotionCategories] = useState<Category[]>([]);
  const [filterSelected, setFilterSelected] = useState<Category[]>([]);

  const getPromotions = useCallback(
    async (props: PromotionFilter) => {
      try {
        dispatch(setLoadingPromotion(true));
        const res = await PromotionsApi.getPromotions(props);
        dispatch(setPromotions(res.data.promotions));
        dispatch(setTotal(res.data.total));
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingPromotion(false));
      }
    },
    [dispatch]
  );

  const handleGetPromotionCategoriesData = useCallback(async () => {
    try {
      const res = await PromotionsApi.getPromotionCategories({});
      const data = res.data;
      let categories: Category[] = [];
      for (let i = 0; i < data.length; i++) {
        let category: Category = {
          ...data[i],
          child: [],
        };
        if (category.parent === 0) {
          category.child = data.filter((e) => e.parent === category.id);
          categories.push(category);
        }
      }
      setPromotionCategories(categories);
    } catch (error: any) {
      console.log(error);
    } finally {
    }
  }, [setPromotionCategories]);

  useEffect(() => {
    const filters = filterSelected.filter(
      (filter) => !filter.child || filter.child.length === 0
    );
    const slugArray = filters.map((obj) => obj.slug);
    const resultString = slugArray.join(',');
    if (resultString !== promotionFilter.cats) {
      dispatch(setPromotions([]));
      getPromotions({
        ...promotionFilter,
        cats: resultString,
        page: 1,
      });
      dispatch(
        setPromotionFilter({
          ...promotionFilter,
          cats: resultString,
          page: 1,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSelected, dispatch, getPromotions]);

  const handleFilterSelect = useCallback(
    (selected: Category) => {
      if (filterSelected.includes(selected)) {
        const arr = filterSelected.filter((filter) => filter !== selected);
        setFilterSelected(arr);
      } else {
        const arr = [...filterSelected, selected];
        setFilterSelected(arr);
      }
    },
    [filterSelected]
  );

  const handleFilterReset = useCallback(() => {
    setFilterSelected([]);
    getPromotions({
      ...promotionFilter,
      cats: '',
      page: 1,
    });
    dispatch(
      setPromotionFilter({
        ...promotionFilter,
        cats: '',
        page: 1,
      })
    );
  }, [getPromotions, promotionFilter, dispatch]);

  useEffect(() => {
    if (current === 2) {
      handleGetPromotionCategoriesData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pathSteps = useMemo(() => {
    return [
      {
        name: 'Member area',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'HomeTab',
          });
        },
      },
      {
        name: 'Dinning',
      },
      {
        name: title,
      },
    ];
  }, [title]);
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View
        style={{
          maxWidth: 1250,
          width: '90%',
          marginHorizontal: 'auto',
          marginTop: 10,
          minHeight: 500,
        }}
      >
        <PagePath pathSteps={pathSteps} />
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginVertical: 30,
          }}
        >
          <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
            <UserWebInfo />
            <View
              style={{
                marginTop: 30,
                backgroundColor: STYLE_VARS.fccLightGrey,
              }}
            >
              <Sidebar data={DINNING_TABS} current={current} />
            </View>
            {current === 2 && (
              <View style={{ marginTop: 60 }}>
                <View style={styles.filterWrapper}>
                  <Image
                    source={
                      IS_WEB
                        ? addBase64Prefix(filter_button)
                        : require('../../assets/phone-white.png')
                    }
                    style={{ width: 24, height: 24, marginRight: 8 }}
                  />
                  <Text style={styles.filterText}>Filter Promotion</Text>
                </View>
                <View style={{ flexDirection: 'column' }}>
                  {promotionCategories.map((category) => (
                    <TouchableOpacity
                      style={[styles.selectWrapper, { alignSelf: 'flex-start' }]}
                      key={category.id}
                      onPress={() => handleFilterSelect(category)}
                    >
                      <View style={styles.selectedBox}>
                        {filterSelected.includes(category) && (
                          <View
                            style={{
                              width: '100%',
                              height: '100%',
                              borderColor: STYLE_VARS.primaryColor,
                              borderWidth: 5,
                            }}
                          ></View>
                        )}
                      </View>
                      <Text style={styles.selectedText}>
                        {decode(category.name)}
                      </Text>
                    </TouchableOpacity>
                  ))}
                  {filterSelected.map((selected) => {
                    if (selected.child && selected.child.length > 0) {
                      return (
                        <View key={selected.id}>
                          <View
                            style={{ flexDirection: 'row', marginBottom: 20 }}
                          >
                            <View>
                              <Image
                                source={
                                  IS_WEB
                                    ? addBase64Prefix(filter_button)
                                    : require('../../assets/phone-white.png')
                                }
                                style={{ width: 17, height: 17, marginRight: 8 }}
                              />
                            </View>
                            <Text style={styles.selectedText}>
                              ALL {decode(selected.name)}
                            </Text>
                          </View>
                          {selected.child.map((filter) => (
                            <TouchableOpacity
                              style={[
                                styles.selectWrapper,
                                { alignSelf: 'flex-start' },
                              ]}
                              key={filter.id}
                              onPress={() => handleFilterSelect(filter)}
                            >
                              <View style={styles.selectedBox}>
                                {filterSelected.includes(filter) && (
                                  <View
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      borderColor: STYLE_VARS.primaryColor,
                                      borderWidth: 5,
                                    }}
                                  ></View>
                                )}
                              </View>
                              <Text style={styles.selectedText}>
                                {decode(filter.name)}
                              </Text>
                            </TouchableOpacity>
                          ))}
                        </View>
                      );
                    }
                  })}
                  <TouchableOpacity
                    style={[styles.selectWrapper, { alignSelf: 'flex-start' }]}
                    onPress={() => handleFilterReset()}
                  >
                    <Image
                      source={
                        IS_WEB
                          ? addBase64Prefix(reset_icon)
                          : require('../../assets/reset-icon.png')
                      }
                      style={{
                        width: 17,
                        height: 17,
                        marginRight: 8,
                      }}
                    />
                    <Text style={styles.selectedText}>RESET FILTER</Text>
                  </TouchableOpacity>
                </View>
              </View>
            )}
            <Promotions />
          </View>
          <View style={{ width: '75%' }}>
            <PageTitle
              icon={icon}
              title={title}
              haveGoBackButton={haveGoBackButton}
            />
            {children}
          </View>
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default DinningLayout;

const styles = StyleSheet.create({
  selectWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  selectedText: {
    fontSize: 15,
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  selectedBox: {
    width: 17,
    height: 17,
    borderWidth: 0.5,
    borderColor: COLORS.DARK_GREY,
    borderRadius: 2,
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: COLORS.DARK_GREY,
    paddingBottom: 15,
    marginBottom: 15,
  },
  filterText: {
    fontSize: 16,
    letterSpacing: 2,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: COLORS.GREEN,
    textTransform: 'uppercase',
  },
});
